import { render, staticRenderFns } from "./ViewBalanceGroup.vue?vue&type=template&id=6e715878&scoped=true"
import script from "./ViewBalanceGroup.vue?vue&type=script&lang=js"
export * from "./ViewBalanceGroup.vue?vue&type=script&lang=js"
import style0 from "./ViewBalanceGroup.vue?vue&type=style&index=0&id=6e715878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e715878",
  null
  
)

export default component.exports